import React, { useRef, useState, useEffect } from "react";
import { useAuth } from "@/lib/AuthContext";
import { useActiveCampaign } from "@/api/hooks";
import GiveawayHeader from "../components/giveaway/GiveawayHeader";
import HeroV2 from "../components/giveaway/HeroV2";
import StatsSection from "../components/giveaway/StatsSection";
import AboutMom3ntum from "../components/giveaway/AboutMom3ntum";
import CommunitySection from "../components/giveaway/CommunitySection";
import GiveawayRaffle from "../components/giveaway/GiveawayRaffle";
import HowItWorks from "../components/giveaway/HowItWorks";
import PrizesSection from "../components/giveaway/PrizesSection";
import FAQSection from "../components/giveaway/FAQSection";
import GiveawayFooter from "../components/giveaway/GiveawayFooter";
import SignUpCTASection from "../components/campaign/SignUpCTASection";
import LandingTasksSection from "../components/campaign/LandingTasksSection";
import NoCampaign from "../components/giveaway/NoCampaign";

export default function GiveawayCopy() {
  const tasksRef = useRef(null);
  const { isAuthenticated: loggedIn, login } = useAuth();

  const { data: campaignData } = useActiveCampaign();
  const useCampaignSystem = campaignData?.active === true;

  const scrollToTasks = () => {
    if (!loggedIn) {
      login();
    } else {
      tasksRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const refCode = params.get("ref");
    if (refCode) {
      sessionStorage.setItem("pending_referral", refCode);
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  // Dynamic mode: no active campaign → show placeholder
  if (useCampaignSystem && campaignData && !campaignData.active) {
    return <NoCampaign />;
  }

  // Get page_config if dynamic mode is on
  const pc = useCampaignSystem ? campaignData?.page_config : null;

  return (
    <div className="min-h-screen overflow-x-hidden w-full" style={{ background: "#000000" }}>
      <GiveawayHeader onLoginClick={() => login()} />
      {(!pc || pc.hero?.visible !== false) && (
        <HeroV2 onScrollToForm={scrollToTasks} loggedIn={loggedIn} config={pc?.hero} />
      )}
      {(!pc || pc.about?.visible !== false) && (
        <AboutMom3ntum config={pc?.about} />
      )}
      {(!pc || pc.stats?.visible !== false) && (
        <StatsSection config={pc?.stats} />
      )}
      {(!pc || pc.community?.visible !== false) && (
        <CommunitySection config={pc?.community} />
      )}
      {(!pc || pc.raffle?.visible !== false) && (
        <GiveawayRaffle onScrollToForm={scrollToTasks} loggedIn={loggedIn} config={pc?.raffle} />
      )}
      {(!pc || pc.howItWorks?.visible !== false) && (
        <HowItWorks onScrollToForm={scrollToTasks} loggedIn={loggedIn} config={pc?.howItWorks} />
      )}
      {(!pc || pc.prizes?.visible !== false) && (
        <PrizesSection config={pc?.prizes} />
      )}
      {(!pc || pc.faq?.visible !== false) && (
        <FAQSection config={pc?.faq} />
      )}
      {loggedIn ? (
        <div ref={tasksRef}>
          <LandingTasksSection theme="dark" />
        </div>
      ) : (!pc || pc.cta?.visible !== false) ? (
        <SignUpCTASection config={pc?.cta} sectionRef={null} onLoginClick={() => login()} />
      ) : null}
      <GiveawayFooter />
    </div>
  );
}
